<template>
  <div class="container">
    <van-image width="100%" :src="activityDetail.coverImage" />
    <section class="page-title">
      <van-image :src="require('@/assets/culturalRelic/baoming@2x.png')" />
      <p>{{ activityDetail.title }}</p>
    </section>
    <section class="page-body">
      <van-image class="pattern" :src="require('@/assets/culturalRelic/wen@2x.png')" />
      <section class="detail">
        <div class="content" v-html="activityDetail.introduce"></div>
      </section>
      <section class="section">
        <h4>活动时间：</h4>
        <div>{{ activityDetail.activityTime }}</div>
      </section>
      <section class="section">
        <h4>活动对象：</h4>
        <div>{{ activityDetail.allowAgeStr }}</div>
      </section>
      <section class="section">
        <h4>参与人数：</h4>
        <div>{{ activityDetail.participantsNum }}</div>
      </section>
      <section class="section">
        <h4>签到地点：</h4>
        <!-- <div>{{ activityDetail.gatherSignLocation }}</div> -->
        <div>{{ activityDetail.signLocation }}</div>
      </section>
      <section class="section">
        <h4>咨询电话：</h4>
        <div>{{ activityDetail.consultationPhone }}</div>
      </section>
      <section class="section">
        <h4>报名方式：</h4>
        <div>长按识别下方二维码</div>
        <img src="" alt="">
      </section>
      <div class="tip topTip">
        *注意： 如果三次报名未到场参加，您将无法报名本年度其他活动！
      </div>
      <div>
      </div>
    </section>
  </div>
</template>

<script>
import { getActivityDetail, submitApply } from '@/api/educational'
export default {
  name: 'EducationalSignup2',
  data: () => ({
    activityDetail: {},
    detail: '<p>hello world</p>',
    form: {
      group: [{
        name: null,
        idNumber: null,
        age: null
      }]
    }
  }),
  created () {
    const id = this.$route.query.id
    id && this.getActivityDetail(id)
  },
  methods: {
    async getActivityDetail (id) {
      const { result } = await getActivityDetail(id)
      console.log(result)
      this.activityDetail = result
    },
    onChangeStepper (direction) {
      if (direction === 'down') {
        this.form.group.pop()
      } else {
        this.form.group.push({
          name: '',
          idNumber: null,
          age: null
        })
      }
    },
    async onSubmit (event) {
      console.log(event)
      try {
        const { result } = await submitApply({
          eduId: this.$route.query.id,
          sessionId: event.radio,
          num: event.stepper,
          phone: event.phoneNumber,
          detailList: this.form.group
        })
        console.log(result)
        this.$toast.success('报名成功')
        this.$router.push('/educational/signResult?id=' + this.$route.query.id)
      } catch (err) {
        this.$toast.fail(err)
      }
    },
    computedAge (idCard, index) {
      console.log(idCard, index)
      this.form.group[index].age = this.getAgeFormIdCard(idCard)
    },
    getAgeFormIdCard (idCard) {
      const length = idCard.length
      const date = new Date()
      const month = date.getMonth() + 1
      const day = date.getDate()
      let age = 0
      if (length === 18) {
        age = date.getFullYear() - idCard.substring(6, 10) - 1
        if (idCard.substring(10, 12) < month || (idCard.substring(10, 12) === month && +idCard.substring(12, 14) <= day)) age++
      }
      if (length === 15) {
        age = date.getFullYear() - idCard.substring(6, 8) - 1901
        if (idCard.substring(8, 10) < month || (idCard.substring(8, 10) === month && +idCard.substring(10, 12) <= day)) age++
      }
      return age
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-cell__title {
  padding-right: 15px;
}
::v-deep .van-cell--required::before {
  top: 10px;
  left: 10px;
}
.colors {
  color:#906F5D;
  vertical-align: middle;
}
.content {
  font-size: 13px;
  line-height: 1.8;
  ::v-deep img {
    width: 100%;
    height: auto;
  }
}
.container {
  font-family: 'PingFangMedium';
  min-height: 100vh;
  background-color: #F7EEE8;
  overflow: hidden;
  .Tips {
    font-size: 14px;
    font-weight: 400;
    color:#835F4B;
  }
  ::-webkit-input-placeholder { color:#BAA69C; }
  .page-title {
    margin: 0 12px;
    background: #F3E6DD;
    box-shadow: 0 0 10px 0 rgba(110, 99, 93, .3);
    border-radius: 6px;
    padding: 20px 12px;
    box-sizing: border-box;
    position: relative;
    top: -14px;
    z-index: 2;
    .van-image {
      width: 108px;
    }
    p {
      text-align: center;
      font-size: 14px;
      line-height: 1.4;
    }
  }
  .page-body {
    margin: 0 12px;
    margin-bottom: 20px;
    background: #F3E6DD;
    box-shadow: 0px 0px 10px 0px rgba(110, 99, 93, 0.3);
    border-radius: 7px;
    padding: 16px 14px;
    box-sizing: border-box;
    color: #312925;
    line-height: 1.7;
    position: relative;
    .section {
      font-size: 14px;
    }
    .topTip {
      width: 100%;
      text-align: left;
    }
    .tip {
      margin-top: 20px;
      color: #773f36;
      font-size: 13px;
      line-height: 1.2;
    }
    h4 {
      margin: 0;
      margin-top: 20px;
      display: inline-block;
      font-size: 14px;
    }
    .pattern {
      width: 242px;
      position: absolute;
      right: -12px;
      top: -25px;
      z-index: 2;
    }
    .detail {
      .content {
        ::v-deep img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
  .signup-form {
    .form {
      ::v-deep .nameyz {
        &::before {
          left: 36px;
        }
      }
      > div {
        &:first-child {
          padding: 0 25px;
        }
        .van-radio-group {
          width: 100%;
          //box-shadow: inset 0 0 4px 0 rgba(110, 99, 93, .3);
          //border: 1px solid #ccc;
          background-color: #F1E6DD;
          border-radius: 3px;
        }
        .van-radio {
          align-items: flex-start;
          padding: 12px 10px;
        }
        ::v-deep .van-radio__icon .van-icon {
          font-size: 0.6em;
        }
        .tip {
          font-size: 10px;
          color: #773F36;
          line-height: 2;
          margin-left: 85px;
        }
        ::v-deep .van-stepper {
          > button, input {
            background-color: transparent;
            border: none;
            box-shadow: none;
          }
          > button {
            color: #773f36;
          }
        }
        ::v-deep .van-field__control {
          justify-content: flex-end;
        }
        &:nth-child(2) {
          padding: 0 25px;
          ::v-deep .item {
            padding: 13px 0;
            //border: 1px solid #ccc;
            //box-shadow: inset 0 0 4px 0 rgba(110, 99, 93, .3);
            background-color: #F1E6DD;
            margin-bottom: 10px;
            .van-field__body {
              input, textarea {
                //border: 1px solid #aaa;
                //box-shadow: inset 0 0 3px #ccc;
                background-color: #F7EEE8;
                border-radius: 3px;
                padding: 0 6px;
              }
              input {
                height: 35px;
              }
              textarea {
                height: 100px;
              }
            }
          }
        }
        &:nth-last-child(2) {
          margin: 0 24px 0 24px;
          color: #312925;
          background-color: #F1E6DD;
          padding: 20px 10px;
          box-sizing: border-box;
          text-align: justify;
          h5 {
            font-size: 16px;
            font-weight: 400;
            line-height: 1.8;
            margin: 15px 0;
            margin-top: 0;
            text-align: center;
          }
          .content {
            font-size: 14px;
            line-height: 1.8;
            color: #666666;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .pattern {
      width: 108px;
      margin-left: 29px;
    }
    p {
      margin-left: 29px;
    }
    ::v-deep .van-cell {
      background-color: transparent;
      .van-field__label {
        width: 5em;
        margin-right: 0;
        padding-top: 6px;
      }
      &.van-field {
        padding: 5px 15px;
      }
      .van-field__word-limit {
        margin-top: -18px;
        margin-right: 8px;
      }
      .van-field__body {
        input, textarea {
          //border: 1px solid #aaa;
          //box-shadow: inset 0 0 3px #ccc;
          background-color: #F1E6DD;
          border-radius: 3px;
          padding: 0 6px;
        }
        input {
          height: 35px;
        }
        textarea {
          height: 100px;
        }
      }
    }
  }
  ::v-deep .van-button {
    font-size: 16px;
    display: block;
    height: 33px;
    margin: 26px auto;
    padding: 8px 30px;
    .van-button__text {
      color: #eee;
    }
  }
}
</style>
